import { scaleQuantize } from '@visx/scale';
import { bisector } from 'd3';
export function invertBandScale(xScale, x) {
    var domain = xScale.domain();
    var range = xScale.range();
    if (domain.length === 0)
        return NaN;
    var scale = scaleQuantize().domain(range).range(domain);
    return scale(x);
}
export function getYFromX(data, xScale, x, accessors) {
    var bisectDate = bisector(function (d) {
        var val = accessors.x(d);
        return val;
    }).left;
    // TODO: This should accept a union of ScaleBand and ScaleTime, then narrow.
    // If scale does not have `invert` method, treat it as a bounded scale
    var xVal = xScale.invert !== undefined ? xScale.invert(x) : invertBandScale(xScale, x);
    var index = bisectDate(data, xVal);
    return data[index];
}
export function getCoordValues(_a) {
    var rect = _a.rect, accessors = _a.accessors, series = _a.series, xScale = _a.xScale, mouseX = _a.mouseX, mouseY = _a.mouseY, colorScheme = _a.colorScheme;
    if (rect === null)
        return;
    var data = series
        .filter(function (s) { return accessors.data(s).length > 0; })
        .map(function (s) {
        // TODO
        // eslint-disable-next-line array-callback-return
        if (s === undefined)
            return;
        var d = accessors.data(s);
        var datum = getYFromX(d, xScale, mouseX, accessors);
        // TODO
        // eslint-disable-next-line array-callback-return
        if (datum === undefined)
            return;
        return { series: s, datum: datum };
    })
        .filter(function (s) { return s !== undefined; });
    if (data.length === 0)
        return undefined;
    return { data: data, xScale: xScale, mouseX: mouseX, mouseY: mouseY, colorScheme: colorScheme, accessors: accessors };
}
//# sourceMappingURL=utils.js.map